export const SEARCH_ADDRESS_REQUEST = 'SEARCH_ADDRESS_REQUEST';
export const SEARCH_ADDRESS_SUCCESS = 'SEARCH_ADDRESS_SUCCESS';
export const SEARCH_ADDRESS_FAILURE = 'SEARCH_ADDRESS_FAILURE';

export const CLEAR_OPTIONS = 'CLEAR_OPTIONS';
